import { FormFieldRow } from '@/components/forms/BookTradeForm/FormFieldRow'
import { ValueDateField } from '@/components/forms/RunRiskCalibrationForm/fields/ValueDateField'

export interface CustomStrategiesFieldsProps {}

export const CustomStrategiesFields: React.FC<CustomStrategiesFieldsProps> = ({}) => {
  return (
    <FormFieldRow>
      <ValueDateField />
    </FormFieldRow>
  )
}
